import React from 'react';
import { COLOR } from '@src/styles/color';
import Typography from '../Typography';
import { StyledAlertMessage } from './index.style';

const ALERT_COLORS = {
  info: {
    background: COLOR.backgroundPending,
  },
  success: {
    background: COLOR.backgroundApproved,
  },
  error: {
    background: COLOR.backgroundRejected,
  },
  default: {
    background: COLOR.backgroundDefault,
  },
  warning: {
    background: COLOR.backgroundWarning,
  },
};

const AlertMessage = ({
  type,
  message,
  style,
  className,
  startIcon,
  endIcon,
  textProps,
  children,
  styleWrapper,
}) => {
  const alert = ALERT_COLORS[type] || ALERT_COLORS.info;

  return (
    <StyledAlertMessage
      bgcolor={alert.background}
      className={className}
      style={style}
      styleWrapper={styleWrapper}
    >
      <div className="content-wrapper">
        {startIcon && startIcon}
        <Typography
          component={textProps?.component || 'span'}
          variant={textProps?.variant}
          color={textProps?.color}
        >
          {message}
        </Typography>
        {endIcon && endIcon}
      </div>
      {children && <div>{children}</div>}
    </StyledAlertMessage>
  );
};

export default AlertMessage;
